enum PlaceActivationResult {
  successful = 'successful',
  alreadyActivated = 'alreadyActivated',
  tokenInvalid = 'tokenInvalid',
  failed = 'failed',
}

export default PlaceActivationResult;
